
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Button Refresh Arrows","clip-path":"url(#clip0_1634_16661)"}},[_c('path',{attrs:{"id":"Vector","d":"M4.375 11.873V15.623H0.625","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"id":"Vector_2","d":"M15.625 8.12305V4.37305H19.375","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"id":"Vector_3","d":"M15.8604 4.37109C17.1535 5.71824 17.9432 7.46959 18.0967 9.33058C18.2502 11.1916 17.7581 13.0486 16.7033 14.5895C15.6484 16.1303 14.0951 17.2608 12.3046 17.7909C10.5142 18.3211 8.59576 18.2184 6.87207 17.5003","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"id":"Vector_4","d":"M4.13932 15.6257C2.84905 14.2779 2.06183 12.5272 1.90983 10.6675C1.75784 8.80784 2.25034 6.95251 3.30462 5.41306C4.35891 3.87361 5.91078 2.74379 7.69964 2.21332C9.4885 1.68285 11.4054 1.78403 13.1285 2.49988","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1634_16661"}},[_c('rect',{attrs:{"width":"20","height":"20","fill":"white"}})])])])
          )
        }
      }
    